import { useQueryClient, useMutation } from '@tanstack/react-query'
import { breakKeys, timeCardKeys } from '@lib/keys'
import { deleteBreak, postBreak, updateBreak } from '@lib/api'
import { useUserId } from './useUserId'
import { DateTime } from 'luxon'

interface WeekRangeOptions {
  start: DateTime
  end: DateTime
}

export const useAddBreak = ({ start, end }: WeekRangeOptions) => {
  const queryClient = useQueryClient()
  const userId = useUserId()

  return useMutation(postBreak, {
    onSuccess: () => {
      void queryClient.invalidateQueries(breakKeys.all)
      void queryClient.invalidateQueries(
        timeCardKeys.search(userId, start, end),
      )
    },
  })
}

export const useUpdateBreak = ({ start, end }: WeekRangeOptions) => {
  const queryClient = useQueryClient()
  const userId = useUserId()

  return useMutation(updateBreak, {
    onSuccess: () => {
      void queryClient.invalidateQueries(breakKeys.all)
      void queryClient.invalidateQueries(
        timeCardKeys.search(userId, start, end),
      )
    },
  })
}

export const useDeleteBreak = ({ start, end }: WeekRangeOptions) => {
  const queryClient = useQueryClient()
  const userId = useUserId()

  return useMutation(deleteBreak, {
    onSuccess: () => {
      void queryClient.invalidateQueries(breakKeys.all)
      void queryClient.invalidateQueries(
        timeCardKeys.search(userId, start, end),
      )
    },
  })
}
